import { render, staticRenderFns } from "./tierRedirectView.vue?vue&type=template&id=52967f39&scoped=true&"
import script from "./tierRedirectView.vue?vue&type=script&lang=js&"
export * from "./tierRedirectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52967f39",
  null
  
)

export default component.exports